/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesWaterCharacteristicsStatus200, GetUsersPreferencesWaterCharacteristicsStatus204, GetUsersPreferencesWaterCharacteristicsStatus401 } from '../types/GetUsersPreferencesWaterCharacteristics'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesWaterCharacteristics } from '../clients/getUsersPreferencesWaterCharacteristics'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getUsersPreferencesWaterCharacteristicsSuspenseQueryKey = () => [{ url: '/users/preferences/water-characteristics/' }] as const

type GetUsersPreferencesWaterCharacteristicsSuspenseQueryKey = ReturnType<typeof getUsersPreferencesWaterCharacteristicsSuspenseQueryKey>

export function getUsersPreferencesWaterCharacteristicsSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesWaterCharacteristicsSuspenseQueryKey()
  return queryOptions<GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>, GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesWaterCharacteristics({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/water-characteristics/}
 */
export function useGetUsersPreferencesWaterCharacteristicsSuspense<TData = GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, TQueryKey extends QueryKey = GetUsersPreferencesWaterCharacteristicsSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesWaterCharacteristicsSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getUsersPreferencesWaterCharacteristicsSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
